import React from "react";
import { ContentURL, getContentUrl } from "../../Utils/ContentURL";
import { TripDurationAndDistance } from "./TripDurationAndDistance";
import { useAppState } from "../../../Redux/ReduxHooks";
import { BookingStatus } from "../../../Services/BookingEntities";
import moment from "moment";
import cn from "classnames";

/**
 * Display booking addresses from the voice channel (e.g. IVR, Contact center). This is read only. i.e. the user can't change the addresses. The trip duration and the distance between the pickup and destination is also displayed here.
 */
export const BookingAddresses: React.FC = () => {

    const bookingDetails = useAppState(state => state.PhoneToCnp.Booking)!;

    /**
     * Format times in the booking event's timezone. This is important because the booking may have been created in a different timezone than the user's current timezone, and we want to display the times in the booking's timezone.
     */
    const formatTimeInBookingZone = (value: string | null | undefined | moment.Moment) => {
        if (!value) return "";

        if (moment.isMoment(value)) {
            return value.format("h:mm A");
        }

        // Parse the ISO string while preserving its own timezone offset, then format in that same offset.
        return moment.parseZone(value).format("h:mm A");
    };

    const isCancelled = bookingDetails.TrackingInfo.BookingStatusID === BookingStatus.Cancelled || bookingDetails.TrackingInfo.BookingStatusID === BookingStatus.NoJob;
    const cancellationText = bookingDetails.TrackingInfo.BookingStatusID === BookingStatus.NoJob
        ? `Cancelled by driver at ${formatTimeInBookingZone(bookingDetails.LastUpdated)}`
        : `Cancelled at ${formatTimeInBookingZone(bookingDetails.LastUpdated)}`;

    return (
        <div className="tracking-addresses">
            <div className="booking-address">
                <img src={getContentUrl(ContentURL.images.PhoneToCnp.PickupIcon)} />
                <div className={cn("address-connector", { "long-connector": bookingDetails.TrackingInfo.BookingStatusID >= BookingStatus.Completed })}></div>
                <div className="location-times-full">
                    {bookingDetails.TrackingInfo.BookingStatusID === BookingStatus.Completed && bookingDetails.TrackingInfo.PickedupTime && <div className="meter-onoff-times">{`Picked up at ${moment(bookingDetails.TrackingInfo.PickedupTime).format("h:mm A")}`}</div>}
                    {isCancelled && <div className="meter-onoff-times">{cancellationText}</div>}
                    <div className="address-text">{bookingDetails.Pickup.Name}</div>
                </div>
            </div>
            <div className="booking-address">
                <img src={getContentUrl(ContentURL.images.PhoneToCnp.DestinationIcon)} />
                <div className="location-times-full">
                    {bookingDetails.TrackingInfo.BookingStatusID === BookingStatus.Completed && bookingDetails.TrackingInfo.DropoffTime && <div className="meter-onoff-times">{`Dropped off at ${moment(bookingDetails.TrackingInfo.DropoffTime).format("h:mm A")}`}</div>}
                    <div className="address-text">{bookingDetails.DropOff.Name}</div>
                </div>
            </div>
            <TripDurationAndDistance />
        </div>
    )
}